import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Header,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Button,
    Popup } from 'semantic-ui-react'
import { api } from '../../../services/api';
import moment from 'moment';

import Navbarr from '../../../components/Navbar';
import CardTable from '../../../components/CardTable';

import './styles.css';

export default function OwnProductList({ sidebar: Sidebar}) {
    const history = useHistory();
    const [prodStates, setProdStates] = useState({
        isLoadingData: true,
        lasUpdate: "",
        reloadControl: false,
    });

    const [tableData, setTableData] = useState({
        columns: [
            {
                label: 'Identificador',
                field: 'id',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Nome',
                field: 'nome',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Lojas',
                field: 'lojasQtd',
                sort: 'asc',
                width: 400
            },
            {
                label: 'Ações',
                field: 'acao',
                sort: 'asc',
                width: 100
            }
        ],
        rows: [],
    });

    const updateProdsData = () => {
        setProdStates( state => ({
            ...state,
            reloadControl: !state['reloadControl'],
        }));
    }

    useEffect(() => {
        const goToProdEditScreen = (e, prod, index) => {
            e.preventDefault();
            history.push(`/products/${prod['id']}`, {productId: prod['id']});
        }

        const changeProdForTable = (prod, index) => {
            prod['lojasQtd'] = prod['lojas'].length;
            prod['acao'] = <Popup content='Visualizar'
                trigger={
                    <Button basic size='mini' icon='eye' onClick={(e) => goToProdEditScreen(e, prod, index)} />
                } />

            return prod;
        }

        async function fetchProds() {
            setProdStates( state => ({
                ...state,
                isLoadingData: true
            }));
            try {
                let data = await api.getOwnProducts();
                data.forEach((element, index) => { changeProdForTable(element, index)});

                setTableData( state => ({
                  ...state,
                  rows: data
                }));

                setProdStates( state => ({
                    ...state,
                    isLoadingData: false,
                    lastUpdate: moment().format('LT')
                }));
            } catch (err) {
              console.error("Falha ao obter produtos: ", err);
            }
        }

        fetchProds();
    },[prodStates.reloadControl, history]);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"productlist"}></Sidebar>
            </Side>
            <Container>
                <Header>
                    <Navbarr></Navbarr>
                </Header>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px' }}>
                    <CardTable
                        type={'owntProd'}
                        data={tableData}
                        tableTitle={"Produtos"}
                        elementsName={"produtos"}
                        isLoadingData={prodStates['isLoadingData']}
                        lastUpdate={prodStates['lastUpdate']}
                        updateData={updateProdsData}
                    />
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    )
}
